/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { Field as FormField } from 'formik'

// Define props interface that allows all HTML input attributes and Formik Field props
interface CustomFieldProps {
  name: string
  type?: string
  className?: string
  maxLength?: number
  minLength?: number
  id?: string
  placeholder?: string
  disabled?: boolean
  value?: any
  checked?: boolean
  as?: any
  label?: string
  autoFocus?: boolean
  rows?: number
  [key: string]: any // Allow any other props to be passed through
}

const Field: React.FC<CustomFieldProps> = (props) => {
  const { type, className, ...restProps } = props

  // Build className string based on type and existing className
  const computedClassName = (type ? 'form-control ' : '') + 'field-control' + (className ? ' ' + className : '')

  return <FormField {...restProps} type={type} className={computedClassName} />
}

export default Field
